// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beey-app-layout.ant-layout {
  max-width: 50rem;
}
.beey-app-layout.ant-layout a {
  color: #f29f40;
}
.table .ant-table {
  border-radius: 20px;
  box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.15);
  margin: 0 auto;
  margin-bottom: 15px;
}
@media (max-width: 576px) {
  .table .ant-table {
    font-size: 12px;
  }
}
.table .ant-table .ant-table-thead .ant-table-cell:first-child {
  border-top-left-radius: 20px;
}
.table .ant-table .ant-table-thead .ant-table-cell:last-child {
  border-top-right-radius: 20px;
}
.table .ant-table .ant-table-thead > tr > th {
  text-align: center;
  font-weight: 600;
}
@media (max-width: 576px) {
  .table .ant-table .ant-table-thead > tr > th {
    padding: 3px;
  }
}
.table .ant-table .ant-table-thead > tr > th .infoIcon {
  margin-left: 10px;
}
.ant-table-tbody .ant-table-placeholder .ant-table-cell {
  border-radius: 20px;
}
.ant-table-tbody > tr > td {
  border-bottom: 0px;
  transition: none;
  text-align: center;
}
@media (max-width: 576px) {
  .ant-table-tbody > tr > td {
    padding: 10px 5px;
  }
}
.ant-table-tbody > tr:last-child > td:nth-child(1) {
  border-bottom-left-radius: 20px;
}
.ant-table-tbody > tr:last-child > td:nth-child(6) {
  border-bottom-right-radius: 20px;
}
.ant-table-tbody > tr.ant-table-row:last-child:hover > td:first-child {
  border-bottom-left-radius: 20px;
}
.ant-table-tbody > tr.ant-table-row:last-child:hover > td:last-child {
  border-bottom-right-radius: 20px;
}
.ant-table-tbody > tr.ant-table-row-selected:last-child > td:first-child {
  border-bottom-left-radius: 20px;
}
.ant-table-tbody > tr.ant-table-row-selected:last-child > td:last-child {
  border-bottom-right-radius: 20px;
}
.ant-table-empty {
  margin-bottom: 15px;
}
.length {
  display: flex;
  justify-content: space-between;
}
.ant-pagination-item-active {
  border-radius: 50%;
  border-color: #f29f40;
  font-weight: 800;
}
.ant-pagination-item-active:hover {
  border-color: #f29f40;
}
.ant-pagination-item-active:focus {
  border-color: #f29f40;
}
.ant-pagination-item-active:focus a {
  color: #f29f40;
}
.ant-pagination-item-active a {
  color: #f29f40;
}
.ant-pagination-item-active a:hover {
  color: #f29f40;
}
.ant-pagination-item {
  border-radius: 50%;
  font-weight: 600;
}
.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link,
.ant-pagination-prev .ant-pagination-item-link {
  border-radius: 50%;
}
.showVideo-button {
  border: none;
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/StreamTable/style.less"],"names":[],"mappings":"AACA;EACE,gBAAA;AAAF;AADA;EAGI,cAAA;AACJ;AAGA;EACE,mBAAA;EACA,4CAAA;EACA,cAAA;EACA,mBAAA;AADF;AAEE;EAAA;IACE,eAAA;EACF;AACF;AARA;EAWM,4BAAA;AAAN;AAXA;EAcM,6BAAA;AAAN;AAdA;EAiBM,kBAAA;EACA,gBAAA;AAAN;AACM;EAAA;IACE,YAAA;EAEN;AACF;AAvBA;EAuBQ,iBAAA;AAGR;AAEA;EAGM,mBAAA;AAFN;AADA;EAOI,kBAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAII;EAAA;IACE,iBAAA;EADJ;AACF;AAMI;EACE,+BAAA;AAJN;AAMI;EACE,gCAAA;AAJN;AAjBA;EA0BI,+BAAA;AANJ;AApBA;EA6BI,gCAAA;AANJ;AAvBA;EAgCI,+BAAA;AANJ;AA1BA;EAmCI,gCAAA;AANJ;AASA;EACE,mBAAA;AAPF;AAUA;EACE,aAAA;EACA,8BAAA;AARF;AAaA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AAXF;AAYE;EACE,qBAAA;AAVJ;AAYE;EACE,qBAAA;AAVJ;AASE;EAGI,cAAA;AATN;AADA;EAcI,cAAA;AAVJ;AAWI;EACE,cAAA;AATN;AAaA;EACE,kBAAA;EACA,gBAAA;AAXF;AAcA;;;EAGE,kBAAA;AAZF;AAeA;EACE,YAAA;EACA,6BAAA;AAbF","sourcesContent":["//Table\n.beey-app-layout.ant-layout {\n  max-width: 50rem;\n  a {\n    color: @beey-orange-darken;\n  }\n}\n\n.table .ant-table {\n  border-radius: 20px;\n  box-shadow: 5px 4px 15px rgba(0, 0, 0, 0.15);\n  margin: 0 auto;\n  margin-bottom: 15px;\n  @media (max-width: 576px) {\n    font-size: 12px;\n  }\n\n  .ant-table-thead {\n    .ant-table-cell:first-child {\n      border-top-left-radius: 20px;\n    }\n    .ant-table-cell:last-child {\n      border-top-right-radius: 20px;\n    }\n    > tr > th {\n      text-align: center;\n      font-weight: 600;\n      @media (max-width: 576px) {\n        padding: 3px;\n      }\n      .infoIcon {\n        margin-left: 10px;\n      }\n    }\n  }\n}\n.ant-table-tbody {\n  .ant-table-placeholder {\n    .ant-table-cell {\n      border-radius: 20px;\n    }\n  }\n  > tr > td {\n    border-bottom: 0px;\n    transition: none;\n    text-align: center;\n    @media (max-width: 576px) {\n      padding: 10px 5px;\n    }\n  }\n\n  > tr:last-child > td {\n    \n    &:nth-child(1) {\n      border-bottom-left-radius: 20px;\n    }\n    &:nth-child(6) {\n      border-bottom-right-radius: 20px;\n    }\n  }\n\n  > tr.ant-table-row:last-child:hover > td:first-child {\n    border-bottom-left-radius: 20px;\n  }\n  > tr.ant-table-row:last-child:hover > td:last-child {\n    border-bottom-right-radius: 20px;\n  }\n  > tr.ant-table-row-selected:last-child > td:first-child {\n    border-bottom-left-radius: 20px;\n  }\n  > tr.ant-table-row-selected:last-child > td:last-child {\n    border-bottom-right-radius: 20px;\n  }\n}\n.ant-table-empty {\n  margin-bottom: 15px;\n}\n\n.length {\n  display: flex;\n  justify-content: space-between;\n}\n\n//Pagination\n\n.ant-pagination-item-active {\n  border-radius: 50%;\n  border-color: @beey-orange-darken;\n  font-weight: 800;\n  &:hover {\n    border-color: @beey-orange-darken;\n  }\n  &:focus {\n    border-color: @beey-orange-darken;\n    a {\n      color: @beey-orange-darken;\n    }\n  }\n  a {\n    color: @beey-orange-darken;\n    &:hover {\n      color: @beey-orange-darken;\n    }\n  }\n}\n.ant-pagination-item {\n  border-radius: 50%;\n  font-weight: 600;\n}\n\n.ant-pagination-disabled .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link,\n.ant-pagination-prev .ant-pagination-item-link {\n  border-radius: 50%;\n}\n\n.showVideo-button {\n  border: none;\n  background-color: transparent;\n}\n\n@display-sm: ~\"only screen and (min-width:576px) \";@display-md: ~\"only screen and (min-width:768px)\";@display-lg: ~\"only screen and (min-width:992px)\";@display-xl: ~\"only screen and (min-width:1200px)\";@display-xxl: ~\"only screen and (min-width:1680px)\";@font-family: 'Open Sans', sans-serif;@font-size-base: 15px;@font-size-lg: @font-size-base + 2px;@font-size-sm: @font-size-base - 2px;@white: #fff;@beey-orange: #f3ab58;@beey-orange-darken: #f29f40;@beey-yellow-light: #fef9e9;@beey-blue: #698efc;@beey-blue-light: #82a1fc;@primary-color: @beey-orange-darken;@link-color: @beey-orange-darken;@text-color: #444;@text-color-secondary: #888;@heading-color: #303030;@header-height: 5rem;@header-height-sm: 3rem;@header-line-height: 2rem;@playback-height: 65px;@color-error: #95190c;@text-primary-disabled: #999;@text-secondary: #000000;@text-secondary-dimmed: #666;@text-heading1: #000000;@font-weight-semi-bold: 600;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
